import {Box, Button, Card, CardContent, Typography} from '@mui/material';
import {ArrowBack} from '@mui/icons-material';

export interface AdminSeedQuestionNotFoundProps {
  onBack: () => void;
}

export default function AdminSeedQuestionNotFound({onBack}: AdminSeedQuestionNotFoundProps) {
  return (
    <Card>
      <CardContent>
        <Box sx={{textAlign: 'center', py: 4}}>
          <Typography variant="h6" sx={{color: '#666', mb: 2}}>
            Seed Question Not Found
          </Typography>
          <Button startIcon={<ArrowBack />} onClick={onBack} variant="contained" sx={{bgcolor: '#1B263B'}}>
            Back to Seed Questions
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
}
